/**
 * Juntar data e hora (YYYY-MM-DD HH:mm:SS)
 * @exmaple
 * createTimestamp('2001-01-01', '00:00')
 * // => '2001-01-01 00:00:00+00'
 * createTimestamp('2001-01-01', '00:00:00')
 * // => '2001-01-01 00:00:00+00'
 */
export default function createTimestamp(date, time) {
  const timeWithSeconds = time.padEnd(8, ':00')
  const hasTimezone = /([zZ]|[+-]\d{2}:?\d{2}|[+-]\d{2})$/.test(timeWithSeconds)

  return `${date} ${timeWithSeconds}${hasTimezone ? '' : '+00'}`
}
